/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from '@unform/web';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { addYears, endOfDay, startOfDay, subMonths } from 'date-fns';
import { useLocation } from 'react-router-dom';
import InputDate from '../InputDate';
import Select, { IOption } from '../Select';

import { Container } from './styles';
import Input from '../Input';
import InputMask from '../InputMask';
import { KrFilter } from '../KoroIcons';
import api from '~/services/api';

interface IFormData {
  [key: string]: any;
}

interface IFilters {
  onSubmitFilters(data: IFormData): void;
  showBtnClean?: boolean;
  event?: boolean;
  codeVoucher?: boolean;
  document?: boolean;
  type?: boolean;
  types?: IOption[];
  statusHelp?: boolean;
  helps?: IOption[];
  situationHelp?: boolean;
  situations?: IOption[];
  name?: boolean;
  nameUser?: boolean;
  email?: boolean;
  city?: boolean;
  state?: boolean;
  score?: boolean;
  organizer?: boolean;
  category?: boolean;
  categories?: IOption[];
  modality?: boolean;
  modalities?: IOption[];
  status?: boolean;
  statusEvent?: boolean;
  statusPayment?: boolean;
  statusTicket?: boolean;
  order?: boolean;
  ticket?: boolean;
  statusOptions?: IOption[];
  organizersData?: IOption[];
  paymentsData?: IOption[];
  date?: boolean;
  priority?: boolean;
}

const FiltersLists: React.FC<IFilters> = ({
  onSubmitFilters,
  showBtnClean = true,
  event,
  codeVoucher,
  document,
  type,
  types: typesData,
  helps: helpsData,
  situations: situationsData,
  situationHelp,
  statusHelp,
  name,
  nameUser,
  email,
  city,
  state,
  score,
  organizer,
  organizersData,
  category,
  categories: categoriesData,
  modality,
  modalities: modalitiesData,
  status,
  statusEvent,
  statusPayment,
  paymentsData,
  statusTicket,
  order,
  ticket,
  statusOptions,
  date,
  priority,
}) => {
  const location = useLocation();
  const formRef = useRef<FormHandles>(null);
  const [startDate, setStartDate] = useState<Date>(
    startOfDay(subMonths(new Date(), 6))
  );
  const [endDate, setEndDate] = useState<Date>(
    endOfDay(addYears(new Date(), 1))
  );
  const [categories, setCategories] = useState<IOption[]>([]);
  const [statusData, setStatusData] = useState<IOption[]>([]);
  const [modalities, setModalities] = useState<IOption[]>([]);
  const [types, setTypes] = useState<IOption[]>([]);
  const [helps, setHelps] = useState<IOption[]>([]);
  const [situations, setSituations] = useState<IOption[]>([]);
  const [organizers, setOrganizers] = useState<IOption[]>([]);
  const [payments, setPayments] = useState<IOption[]>([]);
  const [events, setEvents] = useState<IOption[]>([]);
  const [eventName, setEventName] = useState('Todos');
  const [debouncedSearch, setDebouncedSearch] = useState(eventName);
  const [organizersAux, setOrganizersAux] = useState<IOption[]>([]);
  const [organizersText, setOrganizersText] = useState('');
  const [eventId, setEventId] = useState<number | undefined>(undefined);
  const [hasPriority, setHasPriority] = useState(false);
  const [situationSelected, setSituationSelected] = useState<IOption | null>({
    id: 'todos-abertos',
    value: 'Todos (abertos)',
    selected: true,
  });

  useEffect(() => {
    if (categoriesData) {
      setCategories([
        {
          id: 'todos',
          value: 'Todos',
          selected: true,
        },
        ...categoriesData.sort((a, b) => a.value.localeCompare(b.value)),
      ]);
    }
  }, [categoriesData]);

  useEffect(() => {
    if (modalitiesData) {
      setModalities([
        {
          id: 'todas',
          value: 'Todas',
          selected: true,
        },
        ...modalitiesData.sort((a, b) => a.value.localeCompare(b.value)),
      ]);
    }
  }, [modalitiesData]);

  useEffect(() => {
    if (statusOptions) {
      setStatusData([
        {
          id: 'todos',
          value: location.pathname.includes('/eventos')
            ? 'Todos (rodando)'
            : 'Todos',
          selected: !statusOptions.find(
            (statusOption) => statusOption.selected
          ),
        },

        ...statusOptions.sort((a, b) => a.value.localeCompare(b.value)),
      ]);
    }
  }, [location.pathname, statusOptions]);

  useEffect(() => {
    if (organizersData) {
      setOrganizers(
        organizersData.sort((a, b) => a.value.localeCompare(b.value))
      );
      setOrganizersAux([
        {
          id: 'todos',
          value: 'Todos',
          selected: !organizersData.find(
            (organizerData) => organizerData.selected
          ),
        },
        ...organizersData.sort((a, b) => a.value.localeCompare(b.value)),
      ]);
    }
  }, [organizersData]);

  useEffect(() => {
    if (paymentsData) {
      setPayments([
        {
          id: 'todos',
          value: 'Todos',
          selected: !paymentsData.find((paymentData) => paymentData.selected),
        },
        ...paymentsData.sort((a, b) => a.value.localeCompare(b.value)),
      ]);
    }
  }, [paymentsData]);

  useEffect(() => {
    if (typesData) {
      setTypes([
        {
          id: 'todos',
          value: 'Todos',
          selected: !typesData.find((typeData) => typeData.selected),
        },
        ...typesData.sort((a, b) => a.value.localeCompare(b.value)),
      ]);
    }
  }, [typesData]);

  useEffect(() => {
    if (helpsData) {
      setHelps([
        {
          id: 'todos',
          value: 'Todos',
          selected: !helpsData.find((helpStatus) => helpStatus.selected),
        },
        ...helpsData.sort((a, b) => a.value.localeCompare(b.value)),
      ]);
    }
  }, [helpsData]);

  useEffect(() => {
    if (!situationsData) return;

    setSituations([
      {
        id: 'todos-abertos',
        value: 'Todos (abertos)',
        selected: situationSelected?.id === 'todos-abertos',
      },
      {
        id: 'todos',
        value: 'Todos',
        selected: situationSelected?.id === 'todos',
      },
      ...situationsData
        .map((option) => ({
          ...option,
          selected: option.id === situationSelected?.id,
        }))
        .sort((a, b) => a.value.localeCompare(b.value)),
    ]);
  }, [situationSelected?.id, situationsData]);

  const handleLoadEvents = useCallback(async (search = '') => {
    const response = await api.get('events/admin', {
      params: {
        search: search.trim(),
        status_ids: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      },
    });

    const data = response.data.map((eventData: any) => ({
      id: eventData.id,
      value: eventData.name,
      selected: false,
    })) as IOption[];

    if (data.length === 0) {
      data.push({
        id: 0,
        value: 'Nenhum evento encontrado',
        selected: false,
        notSelectable: true,
      });
    }

    setEvents(() => {
      return [{ id: -1, value: 'Todos', selected: true }, ...data];
    });
  }, []);

  useEffect(() => {
    handleLoadEvents(debouncedSearch);
  }, [debouncedSearch, handleLoadEvents]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(eventName === 'Todos' ? '' : eventName);
    }, 500); // 500ms de atraso

    return () => clearTimeout(timer); // limpa o timer a cada digitação
  }, [eventName]);

  const handleChangeTextEvent = useCallback((text) => {
    setEventName(text);
  }, []);

  const handleChangeTextOrganizer = useCallback(
    (text) => {
      const filteredData =
        text && text !== 'Todos'
          ? organizers.filter((organizerDataAux) =>
              organizerDataAux.value.toLowerCase().includes(text.toLowerCase())
            )
          : organizers;

      const extraOptions: IOption[] =
        filteredData.length === 0
          ? [
              {
                id: 'none',
                value: 'Nenhum organizador encontrado',
                selected: false,
                notSelectable: true,
              },
            ]
          : filteredData;

      setOrganizersAux([
        {
          id: 'todos',
          value: 'Todos',
          selected: false,
        },
        ...extraOptions,
      ]);
      setOrganizersText(text);
    },
    [organizers]
  );

  const handleSelectOrganizer = useCallback(
    (e) => {
      if (e.value === 'Todos') {
        setOrganizersAux([
          {
            id: 'todos',
            value: 'Todos',
            selected: true,
          },
          ...organizers,
        ]);
        setOrganizersText('Todos');
      } else {
        setOrganizersText(e.value);
      }
    },
    [organizers]
  );

  const handleChangeEvent = useCallback((e) => {
    if (e.value === 'Todos') {
      setEventId(undefined);
      setEventName('Todos');
    } else {
      setEventId(e.id);
      setEventName(e.value);
    }
  }, []);

  const handleSelectSituation = useCallback((e) => {
    setSituationSelected(e);
  }, []);

  return (
    <Container className="">
      <Form ref={formRef} onSubmit={onSubmitFilters}>
        <div className="bg-filter d-lg-flex">
          {!location.pathname.includes('/financeiro') && (
            <div className="text-end">
              <h2 className="h5 fw-semibold d-flex align-items-center mb-2 mb-lg-0">
                <KrFilter size={24} color="#000" className="me-2" />
                Filtros
              </h2>
              {showBtnClean && (
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="btn-clear mt-2 border-0 bg-transparent"
                >
                  Limpar
                </button>
              )}
            </div>
          )}

          {name && (
            <div className="px-lg-2">
              <span className="d-block mb-1">
                {nameUser ? 'Nome' : 'Nome ou Email'}
              </span>
              <Input className="height" name="name" type="text" />
            </div>
          )}

          {document && (
            <div className="px-lg-2">
              <span className="d-block mb-1">CPF</span>
              <InputMask name="document" kind="cpf" className="height" />
            </div>
          )}

          {email && (
            <div className="px-lg-2">
              <span className="d-block mb-1">E-mail</span>
              <Input className="height" name="email" />
            </div>
          )}

          {organizer && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Organizador</span>

              <Select
                name="organizer"
                className="bd-select"
                options={organizersAux}
                onChangeText={handleChangeTextOrganizer}
                value={organizersText}
                onChange={handleSelectOrganizer}
              />
            </div>
          )}

          {city && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Cidade</span>
              <Input className="height" name="city" type="text" />
            </div>
          )}

          {state && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Estado</span>
              <Input className="height" name="state" type="text" />
            </div>
          )}

          {codeVoucher && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Cupom</span>
              <Input className="height" name="codeVoucher" type="text" />
            </div>
          )}

          {event && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Evento</span>
              <Select
                name="eventList"
                className="bd-select"
                options={events.sort((a, b) => {
                  if (a.value === 'Todos') return -1;
                  if (b.value === 'Todos') return 1;
                  return a.value.localeCompare(b.value);
                })}
                onChangeText={handleChangeTextEvent}
                value={eventName}
                onChange={handleChangeEvent}
              />
              <Input
                type="hidden"
                name="event"
                className="d-none"
                value={eventName}
              />
              <Input
                type="hidden"
                name="eventId"
                className="d-none"
                value={eventId}
              />
            </div>
          )}

          {ticket && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Inscrição</span>
              <Input name="ticket" className="height" />
            </div>
          )}

          {order && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Pedido</span>
              <Input name="order" className="height" />
            </div>
          )}

          {statusEvent && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Status evento</span>
              <Select
                name="status"
                className="bd-select"
                options={statusData}
              />
            </div>
          )}

          {statusPayment && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Status&nbsp;pagamento</span>
              <Select
                name="statusPayment"
                className="bd-select"
                options={payments}
              />
            </div>
          )}

          {statusTicket && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Status inscrições</span>
              <Select
                name="statusTicket"
                className="bd-select"
                options={statusData}
              />
            </div>
          )}

          {status && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Status</span>
              <Select
                name="status"
                className="bd-select"
                options={[
                  {
                    id: 'active',
                    value: 'Ativo',
                    selected: true,
                  },
                  {
                    id: 'not-active',
                    value: 'Inativo',
                    selected: false,
                  },
                ]}
              />
            </div>
          )}

          {score && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Score</span>
              <Select
                name="score"
                className="bd-select"
                options={[
                  {
                    id: 'all',
                    value: 'Score',
                    selected: true,
                  },
                  {
                    id: 'event1',
                    value: 'Evento1',
                    selected: false,
                  },
                  {
                    id: 'event2',
                    value: 'Evento2',
                    selected: false,
                  },
                ]}
              />
            </div>
          )}

          {category && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Esportes</span>
              <Select
                name="sports"
                className="bd-select mt-0"
                options={categories}
              />
            </div>
          )}

          {modality && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Modalidade</span>
              <Select
                name="modality"
                className="bd-select mt-0"
                options={modalities}
              />
            </div>
          )}

          {type && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Tipo</span>
              <Select name="type" className="bd-select mt-0" options={types} />
            </div>
          )}

          {statusHelp && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Status</span>
              <Select
                name="statusHelp"
                className="bd-select mt-0"
                options={helps}
              />
            </div>
          )}

          {situationHelp && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Status</span>
              <Select
                name="situationHelp"
                className="bd-select mt-0"
                options={situations}
                onChange={handleSelectSituation}
              />
            </div>
          )}

          {date && (
            <>
              <div className="px-lg-2">
                {!location.pathname.includes('/financeiro') && (
                  <span className="mb-1 d-block">Data</span>
                )}

                <InputDate
                  name="dateStart"
                  selected={startDate}
                  colorSvg="#5D5D5D"
                  onChange={(e) => setStartDate(e as Date)}
                />
              </div>
              <div className="d-flex">
                <span className="small d-block mb-1 lh-lg mt-auto">Até</span>
              </div>
              <div className="px-lg-2 d-flex flex-column justify-content-end">
                <InputDate
                  name="dateEnd"
                  selected={endDate}
                  colorSvg="#5D5D5D"
                  className="mt-auto"
                  onChange={(e) => setEndDate(e as Date)}
                />
              </div>
            </>
          )}

          {priority && (
            <div className="px-lg-2">
              <span className="d-block mb-1">Prioridade</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked={hasPriority}
                  onChange={(e) => setHasPriority(e.target.checked)}
                />
                <Input
                  type="hidden"
                  name="priority"
                  className="d-none"
                  value={hasPriority ? 'true' : 'false'}
                />
              </div>
            </div>
          )}

          <button type="submit" className="btn-filter rounded px-4 py-1">
            Filtrar
          </button>
        </div>
      </Form>
    </Container>
  );
};

export default FiltersLists;
